import * as React from 'react';
import DocumentTitle from 'react-document-title';

import { Commissions } from '../components/accounting/commissions';
import { Header } from '../components/header';

export const CommissionsPage: React.FC = () => (
    <DocumentTitle title="Commissions">
        <div id="container">
            <Header title="Commissions" />
            <div id="content" className="flex-fill">
                <Commissions accounting={false} />
            </div>
        </div>
    </DocumentTitle>
);
